import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=7c8352e6&scoped=true&"
import script from "./SidebarSearch.vue?vue&type=script&lang=js&"
export * from "./SidebarSearch.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSearch.vue?vue&type=style&index=0&id=7c8352e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8352e6",
  null
  
)

export default component.exports